import { FocusLock } from './../utils/focus-lock.js';
import { ScrollLock } from './../utils/scroll-lock.js';

export const initSearch = function() {
  const breakpoint = 1500;
  const overlaySearch = document.querySelectorAll('[data-search-overlay]');
  const btnSearchBurger = document.querySelectorAll('[data-search-burger]');
  const btnSearchSubmit = document.querySelectorAll('[data-search-submit]');
  const scrollLock = new ScrollLock();
  const focusLock = new FocusLock('startFocus: true');
  const body = document.querySelector('body');

  const openSearch = function(item, parentItem) {
    const parentHeader = item.closest('.header');
    parentItem.classList.add('is-active');

    if (parentHeader) {
      scrollLock.disableScrolling();
      body.classList.add('scroll-lock');
      body.classList.add('is-search-open');
    }
    focusLock.lock('.search.is-active');
  }
  const closeSearch = function(item, parentItem) {
    const parentHeader = item.closest('.header');
    if (parentItem.classList.contains('is-active')) {
      parentItem.classList.remove('is-active');
      item.classList.remove('is-active');

      scrollLock.enableScrolling();
      if (body.classList.contains('scroll-lock')) {
        body.classList.remove('scroll-lock');
      }

      if (body.classList.contains('is-search-open')) {
        body.classList.remove('is-search-open');
      }

      if (parentHeader) {
        scrollLock.enableScrolling();
        focusLock.lock('.search.is-active');
      }
      focusLock.unlock('.search.is-active');
    }

    const parentTabs = item.closest('[data-tabs="element"]');
    if (parentTabs) {
      if (parentTabs.classList.contains('is-z-index')) {
        parentTabs.classList.remove('is-z-index');
      }
    }
  }

  if (btnSearchBurger.length > 0) {
    btnSearchBurger.forEach((item) => {
      item.addEventListener('click', function(i) {
        i.preventDefault();

        const parent = item.closest('[data-search-result]');
        if (parent) {
          if (parent.classList.contains('is-active')) {
            closeSearch(item, parent);
          } else {
            openSearch(item, parent);
          }
        } else {
          const searchBlock = document.querySelector('.header [data-search-result]');
          if (searchBlock) {
            if (searchBlock.classList.contains('is-active')) {
              closeSearch(item, searchBlock);
            } else {
              openSearch(item, searchBlock);
            }
          }
        }
      })
    })
  }

  if (overlaySearch) {
    overlaySearch.forEach((item) => {
      item.addEventListener('click', (i) => {
        const evtTarget = i.target;
        const parent = item.closest('[data-search-result]');
        if (evtTarget == item) {
          closeSearch(item, parent);
        }
      })
    })
  }

  window.addEventListener('keydown', function(e) {
    if (e.keyCode == 27) {
      const boxSearchOpen = document.querySelector('.is-active[data-search-result]');
      if (boxSearchOpen) {
        boxSearchOpen.classList.remove('is-active');
        scrollLock.enableScrolling();
        if (body.classList.contains('scroll-lock')) {
          body.classList.remove('scroll-lock');
        }

        if (body.classList.contains('is-search-open')) {
          body.classList.remove('is-search-open');
        }

        focusLock.unlock('.search.is-active');
      }
    }
  }, true)
}
